<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- ============================================= -->
    <!-- 1. لوحة التحكم والإعدادات (تختفي عند الطباعة) -->
    <!-- ============================================= -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-primary fw-bold">
          <i class="fas fa-print ms-2"></i> طباعة كشوف المناداة (إدارة كاملة)
        </h5>
      </div>
      <div class="card-body">
        
        <!-- الفلاتر -->
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="fw-bold">الفصل الدراسي</label>
            <select v-model="form.term_id" class="form-select">
              <option v-for="t in terms" :key="t.id" :value="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="fw-bold">الإدارة التعليمية</label>
            <select v-model="form.admin_id" class="form-select">
              <option v-for="a in administrations" :key="a.id" :value="a.id">{{ a.dep_name }}</option>
            </select>
          </div>
          <div class="col-md-3">
             <label class="fw-bold">سعة الصفحة (طالب)</label>
             <input type="number" v-model.number="rowsPerPage" class="form-control" min="10" max="30">
          </div>
          <div class="col-md-3 d-flex align-items-end">
            <button @click="fetchAdminReport" class="btn btn-primary w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
              <span v-else><i class="fas fa-search ms-2"></i> جلب البيانات</span>
            </button>
          </div>
        </div>

        <!-- إعداد أعمدة المواد والتواريخ -->
        <h6 class="fw-bold border-bottom pb-2 mb-3 text-muted">
            <i class="fas fa-edit ms-1"></i> تخصيص أعمدة المواد في الكشف:
        </h6>
        <div class="row g-2 mb-3 align-items-stretch">
    
    <!-- حلقة التكرار للمواد -->
    <div class="col-6 col-md-4 col-lg-2" v-for="(sub, index) in subjectsList" :key="index">
        <div class="subject-card p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center position-relative shadow-sm hover-shadow">
            
            <!-- زر الحذف (يظهر بشكل عائم ومنسق) -->
            <button 
                v-if="subjectsList.length > 1" 
                @click="removeSubjectColumn(index)" 
                class="btn btn-danger btn-sm rounded-circle remove-btn shadow-sm"
                title="إزالة المادة"
            >
                <i class="fas fa-times"></i>
            </button>

            <!-- حقل اسم المادة -->
            <div class="input-group input-group-sm mb-2">
                <span class="input-group-text bg-light text-primary border-0"><i class="fas fa-book"></i></span>
                <input 
                    type="text" 
                    v-model="sub.name" 
                    class="form-control border-light bg-light fw-bold text-center" 
                    placeholder="المادة"
                >
            </div>

            <!-- حقل التاريخ -->
            <div class="input-group input-group-sm">
                <span class="input-group-text bg-light text-secondary border-0"><i class="far fa-calendar-alt"></i></span>
                <input 
                    type="text" 
                    v-model="sub.date" 
                    class="form-control border-light bg-light text-center" 
                    placeholder="التاريخ"
                >
            </div>

        </div>
    </div>

    <!-- زر الإضافة -->
    <div class="col-6 col-md-4 col-lg-2">
        <button 
            @click="addSubjectColumn" 
            class="btn btn-outline-success border-dashed w-100 h-100 d-flex flex-column align-items-center justify-content-center p-3 add-card-btn"
        >
            <div class="icon-box mb-2"><i class="fas fa-plus fa-lg"></i></div>
            <span class="fw-bold small">إضافة مادة</span>
        </button>
    </div>

</div>

        <div class="text-center border-top pt-3">
           <button @click="printReport" class="btn btn-dark px-5 fw-bold btn-lg" :disabled="processedData.length === 0">
             <i class="fas fa-print ms-2"></i> طباعة الكشوف المجمعة
           </button>
        </div>

      </div>
    </div>

    <!-- ============================================= -->
    <!-- 2. منطقة الطباعة (التقرير) -->
    <!-- ============================================= -->
    <div id="printMe" v-if="processedData.length > 0">
      
      <!-- الحلقة الأولى: اللجان الامتحانية -->
      <div v-for="(committee, cIdx) in processedData" :key="'comm-'+cIdx" >
        
        <!-- الحلقة الثانية: المدارس داخل اللجنة -->
        <div v-for="(school, sIdx) in committee.schools_data" :key="'school-'+sIdx"  >
            
            <!-- الحلقة الثالثة: الصفحات (Pagination) -->
            <div v-for="(page, pIdx) in school.pages" :key="'page-'+pIdx" class="print-page-wrapper" style="page-break-after: always;">
              
              <!-- جدول الصفحة -->
              <table class="table table-bordered border-dark text-center align-middle w-100 mb-0 table-print" dir="rtl">
                
                <!-- رأس الجدول (الترويسة) -->
                <thead>
                  <tr class="border-0">
                    <th :colspan="3 + subjectsList.length" class="border-0 p-0">
                      
                      <div class="report-header mb-1 mt-2">
                        <div class="row text-center align-items-center">
                          <div class="col-4 text-start small-header fs-18">
                            <h6 class="fw-bold mb-0">محافظة شمال سيناء</h6>
                            <h6 class="fw-bold mb-0">مديرية التربية والتعليم</h6>
                            <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
                          </div>
                          <div class="col-4">
                            <h3 class="fw-bold text-decoration-underline mb-1">كشف مناداة</h3>
                            <div class="badge bg-white text-dark border border-dark px-3 py-1 fs-18">
                              {{ getTermName(form.term_id) }} | 2026
                            </div>
                          </div>
                          <div class="col-4 text-start">
                            <div class="border border-dark p-1 rounded text-center bg-light">
                              <p class="mb-0 fw-bold small fs-18">مقر اللجنة: {{ committee.committee_name  | truncate(40)}}</p>
                              <p class="mb-0 fw-bold small fs-16">رقم اللجنة: ( {{ committee.committee_number }} )</p>
                            </div>
                          </div>
                        </div>
                        <!-- اسم المدرسة -->
                        <div class="mt-2 bg-secondary text-white p-1 text-center rounded d-print-bg-grey">
                           <h5 class="m-0 fw-bold">مدرسة: {{ school.school_name }}</h5>
                        </div>
                      </div>

                    </th>
                  </tr>

                  <!-- عناوين الأعمدة -->
                  <tr class="table-light custom-th">
                    <th width="8%">الجلوس</th>
                    <th width="28%">اسم الطالب / الحالة</th>
                    <th width="7%">الديانة</th>
                    
                    <!-- أعمدة المواد الديناميكية -->
                    <th v-for="(sub, i) in subjectsList" :key="'h-'+i" class="subject-col">
                        {{ sub.name }}
                        <div class="date-sub">{{ sub.date }}</div>
                    </th>
                  </tr>
                </thead>

                <!-- جسم الجدول -->
                <tbody>
                  <tr v-for="student in page.students" :key="student.id">
                    <td class="fw-bold fs-5 font-monospace">{{ student.Seating_No_1 }}</td>
                    <td class="text-start pe-2">
                        <div class="fw-bold  text-nowrap fs-23">{{ student.Arabic_Name | truncate(30) }}</div>
                        <!-- حالات خاصة -->
                        <div v-if="student.Damg_Status_id" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20" style="margin-top: 7px; background-color: gray; color: white;">دمج : {{student.disability_type}}</div>
                        <div v-if="student.Stud_Type_Id == 2" class="d-inline-block small fw-bold border border-dark px-1 ms-1 rounded fs-20">منازل</div>
                    </td>
                    <td class="fs-20">{{ student.Moslem_Name || 'مسلم' }}</td>

                    <!-- خلايا التوقيع -->
                    <td v-for="(sub, i) in subjectsList" :key="'c-'+i"></td>
                  </tr>
                  
                  <!-- صفوف فارغة لضبط ارتفاع الصفحة -->
                  <tr v-for="n in (rowsPerPage - page.students.length)" :key="'empty-'+n" class="empty-row">
                      <td :colspan="3 + subjectsList.length">&nbsp;</td>
                  </tr>
                </tbody>
              </table>

              <!-- تذييل الصفحة -->
              <div class="page-footer mt-1 border-top border-2 border-dark pt-1">
                 <div class="row align-items-center">
                     <div class="col-4 text-end small fw-bold">
                        إجمالي اللجنة: {{ school.stats.total }} طالب
                     </div>
                     <div class="col-4 text-center">
                         <span class="fw-bold small">
                             مدرسة ( {{ sIdx + 1 }} / {{ committee.schools_data.length }} )
                         </span>
                     </div>
                     <div class="col-4 text-start">
                         <span class="fw-bold border border-dark px-2 bg-light small">
                             صـ ( {{ pIdx + 1 }} / {{ school.pages.length }} )
                         </span>
                     </div>
                 </div>
                 <div class="row mt-2 text-center small fw-bold sig-row">
                     <div class="col-4">ملاحظ أول: ............</div>
                     <div class="col-4">ملاحظ ثان: ............</div>
                     <div class="col-4">مراقب الدور: ............</div>
                 </div>
              </div>

              <!-- فاصل الصفحات (إجباري) -->
              <div class="page-break"></div>

            </div> <!-- نهاية حلقة الصفحات -->
            
        </div> <!-- نهاية حلقة المدارس -->
      </div> <!-- نهاية حلقة اللجان -->

    </div>
    
    <!-- رسالة فارغة -->
    <div v-else-if="!loading && searched" class="alert alert-warning text-center no-print mt-4">
        لا توجد بيانات لهذه الإدارة.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "CallingSheetAdministration",
  data() {
    return {
      loading: false,
      searched: false,
      rowsPerPage: 20, // عدد الطلاب في الصفحة الواحدة (قابل للتعديل)
      admins:[],
      // البيانات
      terms: [
          { id: 1, name: 'الفصل الدراسي الأول' },
          { id: 2, name: 'الفصل الدراسي الثاني' }
      ],
      administrations: [], // يتم جلبها من الـ API
      processedData: [],   // البيانات النهائية بعد المعالجة والتقسيم
      
      form: {
        term_id: '',
        admin_id: '',
      },

      // المواد الافتراضية
      subjectsList: [
          { name: 'عربي', date: '18/5' },
          { name: 'إنجليزي', date: '19/5' },
          { name: 'دراسات', date: '20/5' },
          { name: 'جبر', date: '21/5' },
          { name: 'هندسة', date: '22/5' },
          { name: 'علوم', date: '23/5' },
          { name: 'دين', date: '23/5' },
          { name: 'فنية', date: '23/5' },
          { name: 'حاسب', date: '23/5' },
      ]
    };
  },
  filters: {
    truncate(value, limit) {
      if (!value) return '';
      if (value.length <= limit) return value;
      return value.substring(0, limit) + '..';
    }
  },
  mounted() {
    this.fetchAdmins();
    api.get('/getadmins').then(res => this.admins = res.data)
  },
  methods: {
    // 1. جلب الإدارات
    async fetchAdmins() {
        try {
            const res = await api.get('/getadmins'); 
            this.administrations = res.data;
            // this.administrations = [
            //     {id: 1, name: 'إدارة العريش'}, 
            //     {id: 2, name: 'إدارة بئر العبد'}
            // ];
        } catch(e) { console.error(e); }
    },

    // 2. التحكم في أعمدة المواد
    addSubjectColumn() {
        this.subjectsList.push({ name: 'مادة', date: '' });
    },
    removeSubjectColumn(index) {
        this.subjectsList.splice(index, 1);
    },

    // 3. جلب التقرير (الباك إند يجب أن يرسل Structure معين)
    async fetchAdminReport() {
        if(!this.form.admin_id) return alert('يرجى اختيار الإدارة');
        
        this.loading = true;
        this.searched = true;
        this.processedData = [];

        try {
            // طلب الـ API
            const res = await api.get('/admin/getAdminstrationReport', { params: this.form });
            
            // البدء في معالجة البيانات وتقسيمها لصفحات
            this.processPagination(res.data.data);

        } catch (e) {
            console.error(e);
            alert("حدث خطأ أثناء جلب البيانات");
        } finally {
            this.loading = false;
        }
    },

    // 4. الدالة الجوهرية لتقسيم الصفحات (Pagination Logic)
    processPagination(rawData) {
        // rawData هو مصفوفة اللجان
        this.processedData = rawData.map(committee => {
            
            // داخل كل لجنة، نقوم بمعالجة المدارس
            const processedSchools = committee.schools_data.map(school => {
                
                const pages = [];
                const students = school.students;
                
                // تقسيم طلاب المدرسة إلى مجموعات (Chunks)
                for (let i = 0; i < students.length; i += this.rowsPerPage) {
                    pages.push({
                        students: students.slice(i, i + this.rowsPerPage)
                    });
                }

                return { 
                    ...school, 
                    pages: pages // إضافة مصفوفة الصفحات للمدرسة
                };
            });

            return { 
                ...committee, 
                schools_data: processedSchools 
            };
        });
    },

    getTermName(id) {
        const t = this.terms.find(x => x.id == id);
        return t ? t.name : '';
    },

    printReport() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.fs-18 { font-size: 1.1rem; }
.fs-16 { font-size: 1rem; }
.border-dashed { border-style: dashed !important; }

/* إعدادات الطباعة الدقيقة */
@media print {
  @page {
    size: A4 landscape; /* الورقة بالعرض */
    margin: 5mm;        /* هوامش صغيرة */
  }
  
  body { 
      background-color: white; 
      -webkit-print-color-adjust: exact; 
  }
  
  .no-print { display: none !important; }
  #printMe { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }
  
  /* أهم جزء: فواصل الصفحات */
  .page-break { 
      page-break-after: always; 
      height: 0; 
      display: block; 
      clear: both;
  }

  /* تنسيق الجدول */
  .table-print th, .table-print td {
      border: 1px solid #000 !important;
      padding: 2px 4px !important;
      font-size: 11pt !important;
      height: 30px; /* ارتفاع ثابت للصف */
      color: #000 !important;
  }
  
  /* تظليل الرؤوس */
  .custom-th th { 
      background-color: #e0e0e0 !important; 
      font-weight: bold; 
  }
  
  .d-print-bg-grey {
      background-color: #666 !important;
      color: #fff !important;
  }

  /* تنسيق التاريخ أسفل المادة */
  .date-sub {
      font-size: 8pt;
      border-top: 1px solid #555;
      margin-top: 2px;
      color: #333;
  }
  
  /* إخفاء خلفيات البادج الملونة وتحويلها لإطار */
  .badge {
      border: 1px solid #000 !important;
      color: #000 !important;
      background: none !important;
  }
}

.subject-card {
    transition: all 0.3s ease;
    border: 1px solid #e9ecef !important;
}

.subject-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.1) !important;
}

/* زر الحذف العائم */
.remove-btn {
    position: absolute;
    top: -8px;
    left: -8px; /* يظهر في الركن الأيسر العلوي */
    width: 24px;
    height: 24px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    z-index: 10;
    opacity: 0; /* مخفي افتراضياً */
    transition: opacity 0.2s;
}

/* إظهار زر الحذف عند وقوف الماوس على الكارت */
.subject-card:hover .remove-btn {
    opacity: 1;
}

/* تنسيق زر الإضافة */
.border-dashed {
    border: 2px dashed #198754;
    background-color: #f8fffb;
    transition: all 0.3s;
}

.add-card-btn:hover {
    background-color: #e9f7ef;
    transform: scale(0.98);
}

.icon-box {
    width: 30px;
    height: 30px;
    background-color: #198754;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* تحسين حقول الإدخال */
.input-group-text {
    width: 30px;
    justify-content: center;
}
.form-control:focus {
    box-shadow: none;
    background-color: #fff !important;
    border-color: #198754 !important;
}
</style>